import React, { useState } from 'react';
import BulkEditTableComponent from '../../BulkEditTable/BulkEditTable';
import IntegrationFormModal from './IntegrationFormModal';

type Props = {
  integrations: any[];
  setIntegrations: Function;
  organizationId?: string;
  organizationName: string;
};

const LIMIT_PER_PAGE = 15;
export default function IntegrationTable({
  integrations,
  setIntegrations,
  organizationId,
  organizationName,
}: Props) {
  const [currentPage, setCurrentPage] = useState(1);
  const [editingIntegration, setEditingIntegration] = useState<any | null>(null);
  const totalPages = Math.ceil(integrations.length / LIMIT_PER_PAGE);

  const handleSelectRow = (id: number) => {
    setIntegrations(
      integrations.map((integration) =>
        integration.id === id
          ? { ...integration, isSelected: !integration.isSelected }
          : integration,
      ),
    );
  };

  const handleRowClick = (rowData: Record<string, any>) => {
    if (rowData.type === 'CorpCardSync') {
      setEditingIntegration(rowData);
    }
  };

  const handleUpdate = (updated: any) => {
    setIntegrations(integrations.map((i) => (i.id === updated.id ? updated : i)));
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const paginatedData = integrations.slice(
    (currentPage - 1) * LIMIT_PER_PAGE,
    currentPage * LIMIT_PER_PAGE,
  );

  return (
    <>
      <BulkEditTableComponent
        headers={['provider', 'type', 'status']}
        data={paginatedData}
        currentPage={currentPage}
        totalPages={totalPages}
        onClickNextPage={handleNextPage}
        onClickPreviousPage={handlePreviousPage}
        onSelectRow={handleSelectRow}
        onRowClick={handleRowClick}
        allowSelect={false}
      />
      <IntegrationFormModal
        popupOpen={!!editingIntegration}
        closePopup={() => setEditingIntegration(null)}
        organizationId={organizationId}
        orgName={organizationName}
        addIntegration={() => {}}
        integrationToEdit={editingIntegration}
        updateIntegration={handleUpdate}
      />
    </>
  );
}
